import { render, staticRenderFns } from "./warehouseTab.vue?vue&type=template&id=d3bc6304&"
import script from "./warehouseTab.vue?vue&type=script&lang=js&"
export * from "./warehouseTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3bc6304')) {
      api.createRecord('d3bc6304', component.options)
    } else {
      api.reload('d3bc6304', component.options)
    }
    module.hot.accept("./warehouseTab.vue?vue&type=template&id=d3bc6304&", function () {
      api.rerender('d3bc6304', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/salesQuery/tabs/warehouseTab.vue"
export default component.exports